import axios from "axios";
import { getToken } from "@/utils/auth";
import sendError from "./sendError";

/** Dedicated axios instance for file upload APIs (legacy compatible). */
const service = axios.create({
  baseURL: "",
  timeout: 5 * 60 * 1000,
});

service.interceptors.request.use(
  (config) => {
    if (getToken()) {
      config.headers.Authorization = "Bearer " + getToken();
    }
    return config;
  },
  (error) => Promise.reject(error)
);

service.interceptors.response.use(
  (response) => {
    if (!response || !response.data) return response;
    if (response.data.ErrorCode === 3) {
      window.location.href = "/login";
    }
    return response;
  },
  (error) => {
    sendError("Links seem to get inaccessible.");
    return Promise.reject(error);
  }
);

export default service;
